import React, { Component } from 'react';
import style from '../../style/style';
import Loading from '../loading';
import Sold from '../../static/img/sold.svg'
import numeral from 'numeral';
import median from 'median';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import './index.css';
import Arrow from '../../static/img/arrow.svg';
import HouseCard from '../house-card';
import { withRouter } from "react-router-dom";

class PropertySales extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    if (!this.props.data) return (<Loading fill={style.colors.primary} height="32px" width="32px" container={true} />);
    const { data } = this.props;
    const count =  data.ptsWithin.features.length;
    const distance = data.distance;
    const properties = data.ptsWithin.features;

    let priceArr = [];
    let houseArr = [];
    properties.forEach(function(property, index) {
      priceArr.push(numeral(property.properties.price)._value);
      if (index !== 0) {
        houseArr.push(
          <div key={property.properties.input_string}>
          <HouseCard input_string={property.properties.input_string}
                     date={property.properties.date}
                     price={property.properties.price}
                     coords={property.geometry.coordinates}
                     formatted_address={property.properties.formatted_address}
                     distance={property.properties.distance}
  
          />
          </div> 
        )
      }
    });

    const medPrice = numeral(median(priceArr)).format('(0[.]0a)');

    const settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 2,
      slidesToScroll: 2,
      lazyLoad: true,
      responsive: [ { breakpoint: 960, settings: { slidesToShow: 2, slidesToScroll: 2 } }, { breakpoint: 578, settings: { slidesToShow: 1, slidesToScroll: 1 } } ]
    };


    return (
      <div>
        <div
          style={{ ...style.fact.layout, borderBottom: "none", marginBottom: 0 }}
        >
          <div style={{ ...style.fact.left }}>
            <img src={Sold} style={{ width: style.fact.left.width, padding: style.padding, fill: style.colors.primary }} />
          </div>
          <div style={{ ...style.fact.right }}>
            <h2 style={{ ...style.fact.heading, marginBottom: 0 }}>
              { this.props.match.params.type === "Locality" ? `Property sales in this area` : `€${medPrice} median property price` }
            </h2>
            { this.props.match.params.type !== "Locality" ? 
              <p style={{ marginTop: 0, marginBottom: "0.5rem" }}>{`This price is based on a median of ${count} sales within ${distance}, in the last month.`}</p> 
              : <p style={{ marginTop: 0, marginBottom: "0.5rem" }}>{`Recent sales within the greater ${distance} area, in the last month.`}</p> 
            }
            <div style={{ ...style.fact.source, paddingTop: 0 }}>Source: Property price register 2018, <a href="https://www.propertypriceregister.ie/website/npsra/pprweb.nsf/PPR?OpenForm">propertypriceregister.ie</a>.</div>
            <span
              style={{
                textTransform: "uppercase",
                fontSize: "11px",
                color: "#333",
                padding: "0.25rem 0.5rem",
                border: "1px solid #333",
                borderRadius: "4px"
            }}>Beta</span>
          </div>
        </div>
        <div style={{
            marginBottom: "2rem",
            borderBottom: "1px solid #eee",
            paddingBottom: "3rem"
          }}>
          <Slider
            {...settings}
            prevArrow={
              <CarouselArrow />
            }
            nextArrow={
              <CarouselArrow />
            }
            >
            { houseArr }
          </Slider>
        </div>
      </div>
      );
  }
}

export default withRouter(PropertySales);
      
const CarouselArrow = ({
  className,
  onClick
}) => {
  return (
        <button 
          className={className}
          onClick={onClick}>
            <img src={Arrow} height="16px" width="16px" />
        </button>
  );
};


// WEBPACK FOOTER //
// ./src/components/property-sales/index.js